const namespace = "gpupload";

import AppConfig from "@/_config/application-config";
import childRoutes from "./routes";
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "GPUPLOAD",
  namespace,
  description: null,
  version: "1.0.0",
  icon: "mdi-gauge",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,
  parentRoute: "/gpupload",
  defaultRoute: "home",
  childRoutes,
  component: () =>
    import(/* webpackChunkName: "gpupload-parent" */ "@/apps/gpupload/Application.vue"),
  settings: {
    environment: "DEV",
    //grantType: "client_credentials",
    scope: "api://471a9e4a-aa40-4371-9fc7-0a41979f38a7/Read.All",
    clientId: "471a9e4a-aa40-4371-9fc7-0a41979f38a7",
    apiUrl: "https://localhost:44339/api", 
    //apiUrl: "https://as-gpupload-apidev.azurewebsites.net/api",
    //apiUrl: "https://api.nonprd.lyb.com/external/sippa-dev/api",
    authorizeUrl:
    "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
    `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri==${window.location.origin}`,
    tokenUrl:
    "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: true,
    //env_color:'"primary"', //PROD
    powerBiUrl: "",
    frmlink: "",
    appNavigation: [
       {
         icon: "mdi-home",
         text: "Home",
         link: "/gpupload/home"
       }
      ,
       {
         icon: "mdi-account-lock-outline",
         text: "Admin",
         link: "/gpupload/admin",
         roles: ["admin"],
         items: [
          {
            icon: "mdi-hammer-wrench",
            text: "Configuration",
            link: "/gpupload/configurations",
            roles: ["admin"]
          },
          {
            icon: "mdi-account-multiple-outline",
            text: "User Assignment",
            link: "/gpupload/userAssignment",
            roles: ["admin"]
          },
          {
            icon: "mdi-file-document",
            text: "Logs",
            link: "/gpupload/auditLog",
            roles: ["admin"]
          },
        ],
       },
    ],
  },

  store: {
    pageTitle: {
      default: "gpupload",
      storageMode: localStorage,
    },
    userDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    impersonationDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    }
  },
  
};

export default AppConfig.merge(appConfig);
